import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { CloseOutlined } from '@ant-design/icons';
import { ADMIN_ROUTES } from 'constants/routes';
import { Button, Col, Drawer, Image, Row } from 'components';
import { CompetitorBrandDataType } from './../expandableBrandList';
import styles from './../styles.module.scss';

export type CompetitorDataType = {
  supplierName: string;
  supplierId: string;
  brandData: CompetitorBrandDataType[];
};

interface IAllCompetitorDrawer {
  onExpand: () => void;
  drawerState: boolean;
  data?: CompetitorDataType;
}

export const AllCompetitorDrawer: FC<IAllCompetitorDrawer> = React.memo((props) => {
  const { onExpand, drawerState, data } = props;
  const navigate = useNavigate();
  const onRouteChange = useCallback(
    (entityName: string, id: string) => {
      if (entityName === 'supplier') {
        onExpand();
        navigate(`${ADMIN_ROUTES.suppliers.view}/${id}/general`);
      } else {
        navigate(`${ADMIN_ROUTES.brand.view}/${id}/management`);
      }
    },
    [navigate, onExpand]
  );

  return (
    <Drawer
      closeIcon={null}
      placement="left"
      width={471}
      open={drawerState}
      onClose={onExpand}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      title={'Competitor Suppliers'}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={onExpand} type="text" />
      </div>
      <Row gutter={[0, 8]}>
        <Col span={24}>
          <Button
            type={'link'}
            variant={'link'}
            style={{
              color: '#222530',
              textDecoration: 'underline',
              padding: 0,
              margin: 0,
              fontSize: 14,
              fontWeight: 500,
            }}
            onClick={() => onRouteChange('supplier', data?.supplierId as string)}
          >
            {data?.supplierName}
          </Button>
        </Col>
        <Col span={24}>
          <Row className={'gap-6'}>
            {data?.brandData?.map((_brand: any) => (
              <Row key={_brand.id} className={styles.brand_name_box} align={'middle'}>
                {_brand.files?.LOGO && <Image preview={false} width={40} height={30} src={_brand.files?.LOGO} />}
                <Button
                  type={'link'}
                  variant={'link'}
                  style={{
                    color: '#525866',
                    textDecoration: 'underline',
                    padding: 0,
                    margin: 0,
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                  onClick={() => onRouteChange('brand', _brand.id)}
                >
                  {_brand.name}
                </Button>
              </Row>
            ))}
          </Row>
        </Col>
      </Row>
    </Drawer>
  );
});
